var React = require('react');
var Shopify = require('./shopify');
var ScrollToTop = require('./scroll-to-top');

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  componentDidMount: function() {

    document.title = "Gift Card - Ingledew's Shoes";

    this.scrollToTop('gift-card-page');
  },

  render: function() {
    return <main id="content" className="container" role="main">
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                    <p className="lead">{CMS.giftcard.prefix}</p>
                    <h1>{CMS.giftcard.title}</h1>
                    <p>{CMS.giftcard.text}</p>
                    <div className="row img-wrap">
                        <div className="col-md-6 col-md-offset-3">
                            <img src={CMS.giftcard.img} />
                        </div>
                    </div>
                    <a href={CMS.giftcard.btnLink} className="btn btn-primary" target="_blank">{CMS.giftcard.btnText}</a>
                </div>
            </div>
           </main>
  }
})